import Vue from 'vue'
import 'quasar/dist/quasar.ie.polyfills'
import Quasar, {
  QBtn,
  QInput,
  QForm,
  QCard,
  QIcon,
  QSelect,
  QTab,
  QTabPanel,
  QTabPanels,
  QTabs,
  QSeparator,
  QTable,
  QTh,
  QTr,
  QTd,
  QPagination,
  QField,
  QFile,
  QStepper,
  QStep,
  QStepperNavigation,
  QDialog,
  ClosePopup,
  QCardSection,
  QCardActions,
  QMenu,
  QItem,
  QItemSection,
  QList,
  QExpansionItem,
  QRadio,
  QDate,
  QPopupProxy,
  QLayout,
  QPageContainer,
  QImg,
  QDrawer,
  QScrollArea,
  Ripple,
  QHeader,
  QToolbar,
  QAvatar,
  QToolbarTitle
} from 'quasar'

export default () => Vue.use(Quasar, {
  config: {
    brand: {
      primary: '#4694dd',
      secondary: '#ffa35f'
    }
  },
  components: {
    QCard,
    QBtn,
    QInput,
    QForm,
    QIcon,
    QSelect,
    QTab,
    QTabPanel,
    QTabPanels,
    QTabs,
    QSeparator,
    QTable,
    QTh,
    QTr,
    QTd,
    QPagination,
    QField,
    QFile,
    QStepper,
    QStep,
    QStepperNavigation,
    QDialog,
    QCardSection,
    QCardActions,
    QMenu,
    QItem,
    QItemSection,
    QList,
    QExpansionItem,
    QRadio,
    QDate,
    QPopupProxy,
    QLayout,
    QPageContainer,
    QImg,
    QDrawer,
    QScrollArea,
    QHeader,
    QToolbar,
    QAvatar,
    QToolbarTitle
  },
  directives: {
    ClosePopup,
    Ripple
  }
})
